{
  "version": 1,
  "licensePolicy": {
    "allowedFamilies": ["CC0", "CC BY", "CC BY-SA", "Public domain"],
    "adaptation": "Recortada, redimensionada y convertida a WebP por Tago. Las adaptaciones de obras CC BY-SA se distribuyen bajo la misma licencia."
  },
  "routes": {
    "ruta-de-las-flores": {
      "coverId": "ataco-murales",
      "photos": [
        {
          "id": "apaneca",
          "file": "gallery/ruta-de-las-flores/apaneca.jpg",
          "label": "Apaneca",
          "alt": "Casa de montaña rodeada de vegetación en Apaneca.",
          "credit": {
            "title": "Apaneca, El Salvador - panoramio (17)",
            "author": "PABLO NUÑEZ",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Apaneca,_El_Salvador_-_panoramio_(17).jpg"
          }
        },
        {
          "id": "ataco-murales",
          "file": "gallery/ruta-de-las-flores/ataco-murales.jpg",
          "label": "Murales de Ataco",
          "alt": "Murales coloridos en Concepción de Ataco.",
          "credit": {
            "title": "Murales de Ataco 3",
            "author": "Erickssonr",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Murales_de_Ataco_3.JPG"
          }
        },
        {
          "id": "juayua-chorros",
          "file": "gallery/ruta-de-las-flores/juayua-chorros.jpg",
          "label": "Chorros de La Calera",
          "alt": "Cascadas de Los Chorros de La Calera cerca de Juayúa.",
          "credit": {
            "title": "Chorros de La Calera",
            "author": "ElmerGuevara",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Chorros_de_La_Calera.JPG"
          }
        }
      ]
    },
    "ruta-los-volcanes": {
      "coverId": "lago-coatepeque",
      "photos": [
        {
          "id": "cerro-verde",
          "file": "gallery/ruta-los-volcanes/cerro-verde.jpg",
          "label": "Cerro Verde",
          "alt": "Vista verde desde el mirador de Cerro Verde.",
          "credit": {
            "title": "Mirador Cerro Verde",
            "author": "JMRAFFi",
            "license": "CC BY 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mirador_Cerro_Verde.jpg"
          }
        },
        {
          "id": "volcan-izalco",
          "file": "gallery/ruta-los-volcanes/volcan-izalco.jpg",
          "label": "Volcán de Izalco",
          "alt": "El Volcán de Izalco al atardecer.",
          "credit": {
            "title": "Volcan de Izalco atardecer",
            "author": "Raúl Arias",
            "license": "CC BY 2.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Volcan_de_Izalco_atardecer.jpg"
          }
        },
        {
          "id": "lago-coatepeque",
          "file": "gallery/ruta-los-volcanes/lago-coatepeque.jpg",
          "label": "Lago de Coatepeque",
          "alt": "Vista panorámica del Lago de Coatepeque de color turquesa.",
          "credit": {
            "title": "Lago de coatepeque de color",
            "author": "JMRAFFi",
            "license": "CC BY-SA 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lago_de_coatepeque_de_color.jpg"
          }
        }
      ]
    },
    "ruta-panoramica": {
      "coverId": "lago-ilopango",
      "photos": [
        {
          "id": "los-chorros",
          "file": "gallery/ruta-panoramica/los-chorros.jpg",
          "label": "Los Chorros",
          "alt": "Sendero de piedras sobre aguas turquesas en el Parque Nacional Los Chorros.",
          "credit": {
            "title": "LOS CHORROS NATIONAL PARK, EL SALVADOR",
            "author": "Jerrye & Roy Klotz, MD",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:LOS_CHORROS_NATIONAL_PARK,_EL_SALVADOR.jpg"
          }
        },
        {
          "id": "lago-ilopango",
          "file": "gallery/ruta-panoramica/lago-ilopango.jpg",
          "label": "Lago de Ilopango",
          "alt": "Vista elevada del Lago de Ilopango y el volcán de San Vicente.",
          "credit": {
            "title": "El-salvador san-salvador Lago de Ilopango volcán de San Vicente Chichontepec",
            "author": "Arne Müseler",
            "license": "CC BY-SA 3.0 de",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/deed.en",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:El-salvador_san-salvador_Lago_de_Ilopango_volc%C3%A1n_de_San_Vicente_Chichontepec.JPG"
          }
        }
      ]
    },
    "playa-el-tunco": {
      "coverId": "el-tunco",
      "photos": [
        {
          "id": "puerto-la-libertad",
          "file": "gallery/playa-el-tunco/puerto-la-libertad.jpg",
          "label": "Puerto de La Libertad",
          "alt": "Atardecer en el Puerto de La Libertad.",
          "credit": {
            "title": "Atardecer en el puerto de la libertad.",
            "author": "ElmerGuevara",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Atardecer_en_el_puerto_de_la_libertad..JPG"
          }
        },
        {
          "id": "el-tunco",
          "file": "gallery/playa-el-tunco/el-tunco.png",
          "label": "Playa El Tunco",
          "alt": "Formaciones rocosas de Playa El Tunco durante el atardecer.",
          "credit": {
            "title": "El tunco",
            "author": "Rebevon11",
            "license": "CC BY-SA 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:El_tunco.png"
          }
        }
      ]
    },
    "surf-city": {
      "coverId": "surf-city",
      "photos": [
        {
          "id": "surfing",
          "file": "gallery/surf-city/surfing.jpg",
          "label": "Surf en El Salvador",
          "alt": "Surfista salvadoreño montando una ola frente a la costa del país.",
          "credit": {
            "title": "Bryan Pérez surfeando",
            "author": "Casa Presidencial El Salvador",
            "license": "CC0",
            "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bryan_P%C3%A9rez_surfeando.jpg"
          }
        },
        {
          "id": "surf-city",
          "file": "gallery/surf-city/surf-city.jpg",
          "label": "Surf City",
          "alt": "Carretera costera de Surf City al atardecer.",
          "credit": {
            "title": "Surf City II",
            "author": "Casa Presidencial El Salvador",
            "license": "CC0",
            "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Surf_City_II.jpg"
          }
        }
      ]
    },
    "city-tours": {
      "coverId": "centro-historico",
      "photos": [
        {
          "id": "puerta-del-diablo",
          "file": "gallery/city-tours/puerta-del-diablo.jpg",
          "label": "Puerta del Diablo",
          "alt": "Atardecer con la Puerta del Diablo al fondo.",
          "credit": {
            "title": "Atardecer al fondo Puerta del diablo desde Santiago Texacuangos - panoramio",
            "author": "Daniel chavez castro",
            "license": "CC BY 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Atardecer_al_fondo_Puerta_del_diablo_desde_Santiago_Texacuangos_-_panoramio.jpg"
          }
        },
        {
          "id": "planes-de-renderos",
          "file": "gallery/city-tours/planes-de-renderos.jpg",
          "label": "Planes de Renderos",
          "alt": "Vista de San Salvador desde los Planes de Renderos al atardecer.",
          "credit": {
            "title": "Atardecer de San Salvador desde Los Planes de Renderos",
            "author": "José Alejandro Álvarez Ramírez (JOSAL)",
            "license": "CC BY 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Atardecer_de_San_Salvador_desde_Los_Planes_de_Renderos.jpg"
          }
        },
        {
          "id": "centro-historico",
          "file": "gallery/city-tours/centro-historico.jpg",
          "label": "Centro Histórico",
          "alt": "Centro de San Salvador de noche.",
          "credit": {
            "title": "Centro de San Salvador de noche",
            "author": "Kayren22",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Centro_de_San_Salvador_de_noche.JPG"
          }
        }
      ]
    },
    "suchitoto": {
      "coverId": "lago-suchitlan",
      "photos": [
        {
          "id": "suchitoto",
          "file": "gallery/suchitoto/suchitoto.jpg",
          "label": "Suchitoto",
          "alt": "Patio colonial de la Alcaldía Municipal de Suchitoto.",
          "credit": {
            "title": "Alcaldía Municipal de Suchitoto, Cuscatlán, El Salvador.",
            "author": "RodrigoMorán",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alcald%C3%ADa_Municipal_de_Suchitoto,_Cuscatl%C3%A1n,_El_Salvador..JPG"
          }
        },
        {
          "id": "lago-suchitlan",
          "file": "gallery/suchitoto/lago-suchitlan.jpg",
          "label": "Lago de Suchitlán",
          "alt": "Lancha en el Lago de Suchitlán.",
          "credit": {
            "title": "Barco Joseline, Lago Suchitlán",
            "author": "Christopher Arturo Aragón Vides",
            "license": "CC BY-SA 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Barco_%22Joseline%22,_Lago_Suchitl%C3%A1n.jpg"
          }
        }
      ]
    },
    "playas-de-la-union": {
      "coverId": "golfo-de-fonseca",
      "photos": [
        {
          "id": "la-union",
          "file": "gallery/playas-de-la-union/la-union.jpg",
          "label": "La Unión",
          "alt": "Vista de la costa y el muelle de La Unión.",
          "credit": {
            "title": "La Union Salvador",
            "author": "Svs220 at en.wikipedia",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:La_Union_Salvador.JPG"
          }
        },
        {
          "id": "golfo-de-fonseca",
          "file": "gallery/playas-de-la-union/golfo-de-fonseca.jpg",
          "label": "Golfo de Fonseca",
          "alt": "Vista panorámica del Golfo de Fonseca desde Conchagua.",
          "credit": {
            "title": "Conchagua, Golfo de Fonseca",
            "author": "Raúl Arias",
            "license": "CC BY 2.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Conchagua,_Golfo_de_Fonseca.jpg"
          }
        }
      ]
    },
    "chalatenango": {
      "coverId": "la-palma",
      "photos": [
        {
          "id": "chalatenango",
          "file": "gallery/chalatenango/chalatenango.jpg",
          "label": "Chalatenango",
          "alt": "Catedral de Chalatenango.",
          "credit": {
            "title": "Catedral de Chalatenango",
            "author": "Ernesto561",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Catedral_de_Chalatenango.jpg"
          }
        },
        {
          "id": "la-palma",
          "file": "gallery/chalatenango/la-palma.jpg",
          "label": "La Palma",
          "alt": "Artesanías coloridas de La Palma, Chalatenango.",
          "credit": {
            "title": "Artesanias de La Palma Chalatenango",
            "author": "ElmerGuevara",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Artesanias_de_La_Palma_Chalatenango.jpg"
          }
        }
      ]
    },
    "traslado-ejecutivo-aeropuerto": {
      "coverId": "aeropuerto",
      "photos": [
        {
          "id": "aeropuerto",
          "file": "gallery/traslado-ejecutivo-aeropuerto/aeropuerto.jpg",
          "label": "Aeropuerto Internacional",
          "alt": "Avión en el Aeropuerto Internacional Monseñor Óscar Arnulfo Romero.",
          "credit": {
            "title": "TACA Embraer ERJ-190AR at Monseñor Óscar Arnulfo Romero International Airport",
            "author": "Presidency of El Salvador",
            "license": "CC0",
            "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:TACA_Embraer_ERJ-190AR_at_Monse%C3%B1or_%C3%93scar_Arnulfo_Romero_International_Airport.jpg"
          }
        }
      ]
    },
    "evento-noche-de-museos": {
      "coverId": "muna",
      "photos": [
        {
          "id": "muna",
          "file": "gallery/evento-noche-de-museos/muna.jpg",
          "label": "MUNA",
          "alt": "Fachada del Museo Nacional de Antropología Dr. David J. Guzmán.",
          "credit": {
            "title": "Museo Nacional de Antropología Dr. David J. Guzman, El Salvador",
            "author": "Karencita Chavez",
            "license": "CC BY-SA 3.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Museo_Nacional_de_Antropolog%C3%ADa_Dr._David_J._Guzman,_El_Salvador.JPG"
          }
        },
        {
          "id": "plaza-barrios",
          "file": "gallery/evento-noche-de-museos/plaza-barrios.jpg",
          "label": "Centro Histórico",
          "alt": "Palacio Nacional y estatua de Gerardo Barrios en San Salvador.",
          "credit": {
            "title": "Fachada del Palacio Nacional y estatua de Gerardo Barrios (San Salvador)",
            "author": "Raúl Arias",
            "license": "CC BY 2.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Fachada_del_Palacio_Nacional_y_estatua_de_Gerardo_Barrios_(San_Salvador).jpg"
          }
        }
      ]
    },
    "ruta-maya-centroamerica": {
      "coverId": "antigua",
      "photos": [
        {
          "id": "copan",
          "file": "gallery/ruta-maya-centroamerica/copan.jpg",
          "label": "Copán Ruinas",
          "alt": "Estructuras de piedra de las ruinas mayas de Copán.",
          "credit": {
            "title": "Ruinas MAYA Copan Honduras 10",
            "author": "Mónica J. Mora",
            "license": "CC BY-SA 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ruinas_MAYA_Copan_Honduras_10.jpg"
          }
        },
        {
          "id": "copan-guacamaya",
          "file": "gallery/ruta-maya-centroamerica/copan-guacamaya.jpg",
          "label": "Copán",
          "alt": "Guacamaya roja en Copán, Honduras.",
          "credit": {
            "title": "Scarlet macaw (Ara macao cyanopterus) Copan",
            "author": "Charles J. Sharp",
            "license": "CC BY-SA 4.0",
            "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Scarlet_macaw_(Ara_macao_cyanopterus)_Copan.jpg"
          }
        },
        {
          "id": "antigua",
          "file": "gallery/ruta-maya-centroamerica/antigua.jpg",
          "label": "Antigua Guatemala",
          "alt": "Volcán de Agua visto desde Antigua Guatemala.",
          "credit": {
            "title": "Agua Volcano in Antigua Guatemala",
            "author": "Chad Davis",
            "license": "CC BY 2.0",
            "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
            "sourceUrl": "https://commons.wikimedia.org/wiki/File:Agua_Volcano_in_Antigua_Guatemala.jpg"
          }
        }
      ]
    }
  }
}
